"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*!
 * Lazy Load - JavaScript plugin for lazy loading images
*/

var defaults = {
  src: "data-src",
  srcset: "data-srcset",
  selector: ".nx--lazyload"
};

var isIE = document.documentMode || /Edge/.test(navigator.userAgent);

var _class = function () {
  function _class(images, options) {
    _classCallCheck(this, _class);

    this.settings = $.extend(defaults, options || {});
    this.images = images || document.querySelectorAll(this.settings.selector);
    this.observer = null;
    this.init();
  }

  _createClass(_class, [{
    key: "init",
    value: function init() {
      if (!window.IntersectionObserver || isIE) {
        this.loadImages();
        return;
      }

      var self = this;
      var observerConfig = {
        root: null,
        rootMargin: "0px",
        threshold: [0]
      };

      this.observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.intersectionRatio > 0) {
            self.observer.unobserve(entry.target);
            var src = entry.target.getAttribute(self.settings.src);
            var srcset = entry.target.getAttribute(self.settings.srcset);

            if (entry.target.tagName.toLowerCase() === "img") {
              entry.target.onload = function () {
                entry.target.classList.add('is-lazyloaded');
                $(entry.target).trigger('nx.imgloaded');
              };
              entry.target.onerror = function () {
                return entry.target.classList.add('is-lazyloaded-err');
              };

              if (src) {
                entry.target.src = src;
              }
              if (srcset) {
                entry.target.srcset = srcset;
              }
            } else {

              $('<img>').on('load', function () {
                entry.target.classList.add('is-lazyloaded');
                $(entry.target).trigger('nx.imgloaded');
              }).attr('src', src);

              entry.target.style.backgroundImage = "url(" + src + ")";
            }
          }
        });
      }, observerConfig);

      this.images.forEach(function (image) {
        self.observer.observe(image);
      });
    }
  }, {
    key: "loadImages",
    value: function loadImages() {
      var self = this;

      for (var i = 0; i < this.images.length; i++) {
        var src = this.images[i].getAttribute(self.settings.src);
        var srcset = this.images[i].getAttribute(self.settings.srcset);
        if ("img" === this.images[i].tagName.toLowerCase()) {
          if (src) {
            this.images[i].src = src;
          }
          if (srcset) {
            this.images[i].srcset = srcset;
          }
        } else {
          this.images[i].style.backgroundImage = "url(" + src + ")";
        }
        this.images[i].classList.add('is-lazyloaded');
        $(this.images[i]).trigger('nx.imgloaded');
      }

      // this.images.forEach(function (image) {
      //     let src = image.getAttribute(self.settings.src);
      //     let srcset = image.getAttribute(self.settings.srcset);
      //     if ("img" === image.tagName.toLowerCase()) {
      //         if (src) {
      //             image.src = src;
      //         }
      //         if (srcset) {
      //             image.srcset = srcset;
      //         }
      //     } else {
      //         image.style.backgroundImage = "url(" + src + ")";
      //     }
      // });
    }
  }]);

  return _class;
}();

exports.default = _class;


//////////////////
// WEBPACK FOOTER
// ./_js/libs/lazy-load.js
// module id = 9
// module chunks = 0